<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-transparent bg-primary navbar-absolute">
            <div class="container-fluid">
                <p v-if="isSuperAdmin === false" style="font-size: 0.95rem;">{{ curatorMuseum }}</p>
                <div class="collapse navbar-collapse justify-content-end" id="navigation">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a class="nav-link text-white" href="/edit-user">
                                <i class="now-ui-icons users_circle-08"></i>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link text-white" @click="logout">
                                <i class="fa fa-sign-out" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    import User from '../controllers/user.controller';
    import Museums from '../controllers/museum.controller';
    import isSuperAdmin from '../services/jwt/isSuperAdmin';
    import getUID from '../services/firebase/getUID';

    export default {
        name: "Header",
        data: function() {
            return {
                isSuperAdmin: isSuperAdmin(localStorage.getItem('superAdmin')),
                curatorMuseum: null
            }
        },
        beforeMount: async function() {
            if (this.isSuperAdmin === false) {
                let uid = await getUID(localStorage.getItem('superAdmin'));
                let museums = await Museums.getCuratorMuseums(uid);
                if (museums.length > 0) {
                    this.curatorMuseum = museums[0].name;
                }
            }
        },
        methods: {
            logout() {
                User.logout()
                .catch(error => {
                    alert(error.message);
                })
            }
        }
    }
</script>